import { render, staticRenderFns } from "./NewPscInspectionReport.vue?vue&type=template&id=4f2d420a&scoped=true&"
import script from "./NewPscInspectionReport.vue?vue&type=script&lang=js&"
export * from "./NewPscInspectionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2d420a",
  null
  
)

export default component.exports